import { apiConstants } from '../../apiConstant'
import { serviceCall } from '../../serviceCall'

const deleteCompanyApi = (data, callback, errorCallBack) => { 
  return async (dispatch) => {
    serviceCall({
      url: apiConstants.COMPANIES.DELETE_COMPANY,
      method: 'delete',
      data: data,
    })
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}

export default deleteCompanyApi